/* Progressive controls; Shopify's FacetFiltersForm owns URL, section fetches and history. */
(() => {
  if (customElements.get('opale-curated-shop')) return;
  customElements.define('opale-curated-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        const open = event.target.closest('[data-edit-open]');
        if (open) { this.opener = open; open.setAttribute('aria-expanded', 'true'); this.querySelector('dialog').showModal(); return; }
        if (event.target.closest('[data-edit-close]')) { this.querySelector('dialog').close(); return; }
        const view = event.target.closest('[data-edit-view]');
        if (view) {
          this.dataset.view = view.dataset.editView; this.syncViews();
          if (this.dataset.motion !== 'false' && !matchMedia('(prefers-reduced-motion: reduce)').matches) this.viewAnimation = this.querySelector('#product-grid')?.animate([{ opacity: .8 }, { opacity: 1 }], { duration: 160 });
          return;
        }
        const remove = event.target.closest('[data-edit-remove]');
        if (remove && typeof FacetFiltersForm !== 'undefined') {
          event.preventDefault(); this.querySelector('dialog')?.close();
          FacetFiltersForm.renderPage(new URL(remove.href).searchParams.toString());
        }
      }, { signal });
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-edit-filter], [data-edit-sort]');
        if (!form || typeof FacetFiltersForm === 'undefined') return;
        event.preventDefault();
        const params = new URLSearchParams(new FormData(form));
        if (event.submitter?.name) params.set(event.submitter.name, event.submitter.value);
        for (const [key, value] of [...params]) if (value === '') params.delete(key);
        this.querySelector('dialog')?.close();
        this.querySelector('.op-curated-sort')?.removeAttribute('open');
        FacetFiltersForm.renderPage(params.toString());
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.querySelector('.op-curated-sort')?.removeAttribute('open');
      }, { signal });
      document.addEventListener('click', event => {
        const sort = this.querySelector('.op-curated-sort');
        if (sort && !sort.contains(event.target)) sort.removeAttribute('open');
      }, { signal });
      this.bindDialog(); this.syncViews();
    }
    bindDialog() {
      const dialog = this.querySelector('dialog');
      if (!dialog) return;
      this.dialogController?.abort();
      this.dialogController = new AbortController();
      const signal = this.dialogController.signal;
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, { signal });
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const items = Array.from(dialog.querySelectorAll('button,a,input,select,summary')).filter(item => !item.disabled && item.getClientRects().length);
        const first = items[0], last = items.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, { signal });
      dialog.addEventListener('close', () => { this.opener?.setAttribute('aria-expanded', 'false'); this.opener?.focus(); }, { signal });
    }
    syncViews() {
      this.querySelectorAll('.op-shop-card__primary').forEach(image => { image.sizes = this.dataset.view === 'editorial' ? '(min-width: 901px) 46vw, 92vw' : '(min-width: 901px) 30vw, 46vw'; });
      this.querySelectorAll('[data-edit-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.editView === this.dataset.view)));
    }
    renderResults(html, updateEvent) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const filters = parsed.getElementById('CuratedFilters');
      const grid = parsed.getElementById('ProductGridContainer');
      if (!filters || !grid) return false;
      this.querySelector('dialog')?.close();
      this.querySelector('#CuratedFilters').innerHTML = filters.innerHTML;
      this.querySelector('#ProductGridContainer').innerHTML = grid.innerHTML;
      this.querySelector('#ProductGridContainer').removeAttribute('aria-busy');
      this.bindDialog(); this.syncViews();
      this.querySelector('[data-edit-open]')?.focus({ preventScroll: true });
      updateEvent?.resolve(Number(parsed.getElementById('ProductCount').dataset.productCount));
      return true;
    }
    disconnectedCallback() { this.querySelector('dialog')?.close(); this.viewAnimation?.cancel(); this.dialogController?.abort(); this.controller?.abort(); this.controller = null; }
  });
})();
